import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getAllHardware } from '../../../api/hardware';

const useAllHardware = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  systemId?: string
) => {
  return useQuery({
    queryKey: ['allHardware', systemId],
    queryFn: getAllHardware,
    ...options,
  });
};

export default useAllHardware;
